@if (showDialog()) {
  @let note = releaseNote()!;
  <kendo-dialog
    width="50%"
    #dialog="kendoDialog"
    [id]="dialogId"
    (close)="onClose()"
  >
    <div class="d-flex">
      <h1>
        {{ note.headerText ? note.headerText : 'New Release!' }}
      </h1>
      <div class="ms-auto">
        <span
          class="k-icon k-i-close cursor-pointer"
          (click)="onClose()"
        ></span>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <h1 class="subheading mb-11">{{ note.releaseVersionNumber }}</h1>
      <h2 class="subheading">{{ note.displayDate | date }}</h2>
    </div>
    <div class="release-note-body" [innerHTML]="safeShortDescription()"></div>
    <!-- <button kendoButton [primary]="true" class="mb-11">CTA button</button> -->
    <!-- Currently no CTA button for releases. -->
    @if (hasReleaseDetails()) {
      <kendo-card class="w-100 mb-0">
        <kendo-card-header (click)="toggleDetails()">
          {{ showDetails() ? 'Hide' : 'Show' }} Release Details
        </kendo-card-header>
        <!--    <kendo-card-body #details style="transition: max-height 0.5s linear, padding 0.25s linear; overflow:hidden; padding: 0;">-->
        <kendo-card-body #details [hidden]="!showDetails()">
          <div class="details-content">
            @for (fg of usedFeatureGroups(); track fg.sectionHeader) {
              <div>
                <h3 class="mb-7">{{ fg.sectionHeader }}</h3>
                <ul class="mb-0">
                  @for (i of fg.featureNotes; track i) {
                    <li>
                      <p>
                        <strong>{{ i.featureName }}</strong>
                      </p>
                      <div [innerHTML]="i.safeBody"></div>
                    </li>
                  }
                </ul>
                <hr class="separator-regular-dashed mt-7 mb-7" />
              </div>
            }
          </div>
        </kendo-card-body>
      </kendo-card>
    }
    @if (note?.previousReleaseNoteId || note?.nextReleaseNoteId) {
      <div class="release-note-navigation mt-11">
        @if (note?.previousReleaseNoteId) {
          <button
            kendoButton
            class="release-note-navigation-button"
            [disabled]="isNavigating()"
            (click)="loadPreviousRelease()"
          >
            Previous Release
          </button>
        }
        @if (!note?.previousReleaseNoteId) {
          <span></span>
        }
        @if (note?.nextReleaseNoteId) {
          <button
            kendoButton
            class="release-note-navigation-button"
            [disabled]="isNavigating()"
            (click)="loadNextRelease()"
          >
            Next Release
          </button>
        }
      </div>
    }
    <kendo-dialog-actions>
      <button kendoButton themeColor="primary" (click)="onClose()">
        Got it
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
